import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@ui-modules';
import {
  FacilityDriverMapped,
  FacilityVehicleMapped,
  IBookingDetails,
  IBookingDrive,
  IUpdateDrive,
} from '@common/interfaces';

import {
  DriverField,
  DropOffDateField,
  DropOffTimeField,
  PickupDateField,
  PickupTimeField,
  VehicleField,
} from '..';
import './DriveFormItem.styles.scss';

interface DriveDataProps {
  bookingId: string;
  drives: IUpdateDrive[];
}

interface DriveFormItemProps {
  bookingData: IBookingDetails;
  drive: IBookingDrive;
  drivers: FacilityDriverMapped[];
  vehicles: FacilityVehicleMapped[];
  onCancel: (payload: DriveDataProps) => void;
  onChange?: () => void;
}

const DriveFormItem: FC<DriveFormItemProps> = ({
  bookingData,
  drive,
  drivers,
  vehicles,
  onCancel,
  onChange,
}) => {
  const { t } = useTranslation();

  const [isConfirm, setConfirm] = useState(false);

  const onFieldChange = () => {
    onChange?.();
  };

  return (
    <div className="drive-item">
      <div className="drive-item-panel">
        <div className="drive-item-fields">
          <VehicleField
            disabled={!drive.isActive}
            leg={drive.driveNumber}
            vehicle={drive.vehicle}
            vehicles={vehicles}
            onChange={onFieldChange}
          />
          <DriverField
            disabled={!drive.isActive}
            driver={drive.driver}
            drivers={drivers}
            leg={drive.driveNumber}
            vehicles={vehicles}
            onChange={onFieldChange}
          />
          <PickupDateField
            disabled={!drive.isActive}
            leg={drive.driveNumber}
            value={drive.pickupDate}
            onChange={onFieldChange}
          />
          <PickupTimeField
            disabled={!drive.isActive}
            leg={drive.driveNumber}
            value={drive.pickupTime}
            onChange={onFieldChange}
          />
          <DropOffDateField
            disabled={!drive.isActive}
            leg={drive.driveNumber}
            value={drive.dropoffDate}
            onChange={onFieldChange}
          />
          <DropOffTimeField
            disabled={!drive.isActive}
            leg={drive.driveNumber}
            value={drive.dropoffTime}
            onChange={onFieldChange}
          />
        </div>
      </div>

      <div className="drive-item-ctrl">
        {isConfirm ? (
          <>
            <p>{t('planner.messageCancelDriveConfirm')}</p>
            <div className="drive-item-buttons">
              <Button
                className="btn"
                text={t('common.yes')}
                type="button"
                variant="submit"
                onClick={() => {
                  onCancel({
                    bookingId: bookingData.id,
                    drives: [{ is_active: false, uuid: drive.id }],
                  });
                  setConfirm(false);
                }}
              />
              <Button
                className="btn"
                text={t('common.no')}
                variant="danger"
                onClick={() => setConfirm(false)}
              />
            </div>
          </>
        ) : (
          <div className="drive-item-buttons">
            <Button
              className="btn"
              disabled={!drive.isActive}
              text={t('common.btnCancel')}
              variant="danger"
              onClick={() => setConfirm(true)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DriveFormItem;
